import { z } from 'zod';

export const DepositWalletSchema = z.object({
    amount: z
        .string({
            message: 'لطفاً مبلغ را وارد کنید'
        })
        .min(1, 'مبلغ نمی‌تواند خالی باشد')
});

export const InvoiceWalletSchema = z.object({
    method: z.string({
        message: 'لطفا نوع پرداخت را انتخاب کنید'
    })
});

export const InvoiceDiscountSchema = z.object({
    code: z
        .string({
            message: 'لطفا کد تخفیف را وارد کنید'
        })
        .trim()
        .min(3, 'کد تخفیف حداقل 3 رقم میباشد')
});

export type DepositWalletFormValues = z.infer<typeof DepositWalletSchema>;
export type InvoiceWalletFormValues = z.infer<typeof InvoiceWalletSchema>;
export type InvoiceDiscountFormValues = z.infer<typeof InvoiceDiscountSchema>;

